import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import Loading from "vue-loading-overlay";
import VeeValidate from "vee-validate";
import VuexFlash from "vuex-flash";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./registerServiceWorker";
import filters from "./filters";
import "./assets/perivoli.scss"; /* This file imports the Vue Bootstrap CSS */
import x5GMaps from "x5-gmaps";
import LoadScript from "vue-plugin-load-script";
import "vue-loading-overlay/dist/vue-loading.css";
import * as VueGoogleMaps from 'vue2-google-maps';
import { checkToken, sessionCookies } from './utils/helpers';

// add all Bootstrap stuffs
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(x5GMaps, "AIzaSyCQkKXQsrds2UKukVyj4hEIg2JF1Lcia3g");

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBCrposm2KXO8SMiYjOggq5eK54WxIfFoI',
    libraries: 'places',
  }
});

// filters
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]));

Vue.use(VeeValidate, {
  fieldsBagName: "veeFields",
});

Vue.use(VuexFlash, {
  mixin: true,
});

Vue.use(LoadScript);

const accessToken = checkToken() && localStorage.getItem("token");

if (accessToken) {
  axios.defaults.headers.common.Authorization = accessToken;
}

// change to hide/show vue dev tools
Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
